// Number formatting helpers for engineering outputs

export function fmt(
  value: number | null | undefined,
  decimals = 1,
): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  return value.toLocaleString("en-GB", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

// Integer with thousands separators
export function fmtInt(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  return Math.round(value).toLocaleString("en-GB");
}

// Display-only smart rounding: values whose magnitude exceeds 100 are rounded
// to the nearest whole number (the underlying value is unchanged); smaller
// values keep `decimals` precision.
export function fmtSmart(
  value: number | null | undefined,
  decimals = 1,
): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  if (Math.abs(value) > 100) return fmtInt(value);
  return fmt(value, decimals);
}

export function fmtRecirc(nc: number | null | undefined): string {
  if (nc === null || nc === undefined || Number.isNaN(nc)) return "—";
  return `${nc}:1`;
}
